module.exports = __webpack_public_path__ + "static/media/kerry-bio.9a1f3035.pdf";